/**
 * Is noise suppression currently enabled.
 *
 * @param {IState} state - The state of the application.
 * @returns {boolean}
 */
export function isFaceRecognitionEnabled(state) {
    return state['features/face-recognition'].enabled;
}
export function isFaceMeshEnabled(state) {
    return state['features/face-recognition'].maskEnabled;
}
let filterSupport;
/**
 * Checks context filter support.
 *
 * @returns {boolean} True if the filter is supported and false if the filter is not supported by the browser.
 */
export function checkFilterSupport() {
    if (typeof filterSupport === 'undefined') {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        filterSupport = typeof (ctx === null || ctx === void 0 ? void 0 : ctx.filter) !== 'undefined';
        canvas.remove();
    }
    return filterSupport;
}
